import React from 'react';
import { Box, Typography } from '@mui/material';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';

const ListHeaderLabel = ({ column, sortingField, sortingOrder }) => {
  const getFiltersShort = (column) => {
    if (column.id === sortingField) {
      switch (sortingOrder) {
        case 'asc':
          return <ArrowUpward fontSize="small" />;
        case 'desc':
        default:
          return <ArrowDownward fontSize="small" />;
      }
    }
  };
  return (
    <Box
      key={column.id}
      display={'flex'}
      alignItems={'center'}
      justifyContent={column.align === 'right' ? 'flex-end' : 'flex-start'}
    >
      <Typography
        color={'textSecondary'}
        variant={'body2'}
        align={column.align}
      >
        {column.label}
      </Typography>
      {column.id === sortingField && (
        <Box
          display={'flex'}
          alignItems={'center'}
          ml={1}
        >
          {getFiltersShort(column)}
        </Box>
      )}
    </Box>
  );
};

export default ListHeaderLabel;
